import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Service } from './service'

export class ServicesRepository extends BaseRepository<Service> {
    #entityEndpoint
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'services', token, cache)
        this.#entityEndpoint = config.posApiUrl + '/' + 'services'
    }

    async getServiceNames(params: any, useCacheIfNewerThanThisInSeconds: number = 0) {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.config.posApiUrl + '/services/names' + queryString
        if (useCacheIfNewerThanThisInSeconds > 0) {
            const cached = this.resolvedCache.get(url, useCacheIfNewerThanThisInSeconds)
            if (cached) return cached
        }
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') {
            this.resolvedCache.set(url, json, this.#entityEndpoint.split('/')[2])
            return json
        }
        throw message
    }

    async recalculate(serviceId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/services/' + serviceId + '/recalculate?token=' + this.resolvedToken,
            null,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
